<div class="markdown-html text-center">
	<div>{{'workflow.test.completed' | translate}}</div>
	<div class="centered" *ngIf="(workflowItemKey.property$ | async) as values">
		<table>
			<tbody>
				<tr *ngFor="let value of values | keyvalue, let i = index">
					<td class="left-align">{{'workflow.test.result.number' | translate:{'num': i+1} }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding"> {{value.value | number:'1.0-0'}} {{'unit.milliseconds.short' | translate}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
